import Moment from 'moment';
import Datetime from 'react-datetime';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { toast } from 'react-toastify';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    margin: '0 -5px',
  },
  dateTimeWrapper: {
    margin: '0 5px',
  },
});

const dateFormat = 'YYYY-MM-DD';

const EcommerceDateRange = ({ value, onChange, validationCalendar }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const afterVal = value?.after || null;
  const beforeVal = value?.before || null;

  const handleChange = ({ after, before }) => {
    onChange({
      after: after || null,
      before: before || null,
    });
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.dateTimeWrapper}>
        <Datetime
          timeFormat={false}
          dateFormat={Moment.localeData().longDateFormat('L')}
          closeOnSelect={true}
          value={value?.after ? new Moment(value.after) : null}
          isValidDate={validationCalendar}
          onChange={date => {
            const newValue = date.format(dateFormat);
            if (newValue === afterVal) {
              toast.warning(t('ecommerceBags.afterField.warning'));
            } else {
              handleChange({
                after: newValue,
                before: beforeVal,
              });
            }
          }}
          inputProps={{
            placeholder: t('$*common.from'),
            readOnly: true,
          }}
        />
      </div>
      <div style={{ margin: '0 5px' }}>
        <Datetime
          timeFormat={false}
          dateFormat={Moment.localeData().longDateFormat('L')}
          closeOnSelect={true}
          value={value?.before ? new Moment(value?.before) : null}
          isValidDate={validationCalendar}
          onChange={date => {
            const newValue = date.format(dateFormat);
            if (newValue === beforeVal) {
              handleChange({
                after: afterVal,
                before: null,
              });
            } else {
              handleChange({
                after: afterVal,
                before: newValue,
              });
            }
          }}
          inputProps={{
            placeholder: t('$*common.to'),
            readOnly: true,
          }}
        />
      </div>
    </div>
  );
};

export default EcommerceDateRange;
